// Region picker helpers shared by every form that asks for a data-residency region.
//
// `GET /Regions` returns only the regions this installation has configured, as
// `{ regionId, regionName, countryFilterKey }`. `regionName` is a display name (an operator may
// override it), so country restrictions use `countryFilterKey` instead, which is null for a
// renamed region (no restriction).

import { REGION_COUNTRY_MAP } from './countries';

// The picker is shown only when there is a real choice; with one region the form uses it silently.
export const shouldShowRegionPicker = (regions) => (regions?.length ?? 0) > 1;

// Form values are strings. Keeps a preference that names a configured region, falls back to the
// only region when there is exactly one, and otherwise leaves the choice to the user ('').
export const defaultRegionId = (regions, preferredId) => {
  const list = regions ?? [];
  if (
    preferredId !== undefined &&
    preferredId !== null &&
    preferredId !== '' &&
    list.some((r) => String(r.regionId) === String(preferredId))
  ) {
    return String(preferredId);
  }
  if (list.length === 1) return String(list[0].regionId);
  return '';
};

// ISO country codes that address autocomplete is restricted to for the region; [] = no restriction.
export const regionCountryCodes = (region) => {
  const key = region?.countryFilterKey;
  if (!key) return [];
  return REGION_COUNTRY_MAP[String(key).toLowerCase().trim()] ?? [];
};
